import React, {useEffect} from 'react';
import './App.css';
import {Outlet} from "react-router-dom";
import {Button, Grid, Stack} from "@mui/joy";
import {useUITheme} from "./hooks/useUITheme";
import {HOSTNAME} from "./constants";


function App() {
    const uiTheme = useUITheme()

    return (<Stack className="App" sx={uiTheme.backgroundStyle}>
            <Outlet/>
        </Stack>)
}

export default App;
